import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './devQueueProbe';
import './lib/resizeStopper';
import { initTheme } from './lib/theme';

initTheme(); // before render: the first paint must already be in the stored/OS theme

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
